import React, { useState, useEffect, Fragment } from 'react';
import './index.scss';
import _ from 'lodash';
import { connect } from 'react-redux';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import EditViewModal from '../EditViewModal';
import DialogModel from '../Component/Dialog';
import NoDrugs from '../NoDrugs';
import {
  deleteSavedDrug,
  deleteAllDrugs,
  editSavedDrug
} from '../../../services/Api/SavedDrugs/savedDrugService';
import DrugDropdownModal from '../drugDropdownModal';
import Loader from '../../common/Loader';
import { fetchSavedDrugs, setSavedDrugs } from '../../../actions/userDrug';
import { COOKIE_EXPIRY_2MIN } from '../../../constants/defaults';

const SavedDrugsList = props => {
  const [isOpened, setIsOpened] = useState(false);
  const [deleteDrugModal, setDeleteDrugModal] = useState(false);
  const [isClearAllSavedDrugs, setClearAllSavedDrugs] = useState(false);
  const [deleteDrugId, setDeleteDrugId] = useState();
  const [isEditDrug, setIsEditDrug] = useState(false);
  const [editDrugData, setEditDrugData] = useState();
  const [isLoading, setLoading] = useState(true);
  const [notificationError, setNotificationError] = useState('');
  const [dataLayerEventObj, setDataLayerEventObj] = useState({});
  const [drugItems, setDrugItems] = useState([]);

  useEffect(() => {
    setLoading(true);
    props.fetchSavedDrugs();
    setLoading(false);
  }, []);
  useEffect(() => {
    setDrugItems(
      props.savedDrugsData &&
        props.savedDrugsData.drugItems &&
        props.savedDrugsData.drugItems.map(drug => ({
          ...drug,
          isEditLoading: false
        }))
    );
  }, [props.savedDrugsData]);

  const handleDeleteAllDrugs = async () => {
    const deleteAllDrugsResponse = await deleteAllDrugs(
      props.savedDrugsData.saveDrugId
    );
    if (deleteAllDrugsResponse && deleteAllDrugsResponse.success) {
      props.setSavedDrugs({});
    }
    setClearAllSavedDrugs(false);
  };

  const handleDeleteSavedDrug = async () => {
    const deleteDrugDrugsResponse = await deleteSavedDrug(
      props.savedDrugsData.saveDrugId,
      deleteDrugId
    );
    if (deleteDrugDrugsResponse && deleteDrugDrugsResponse.saveDrugId) {
      // calling get drugs api to refresh list
      _.triggerGTMVirtualPageViewEvent({
        event: 'savedDrugsDeleteDrugConfirm',
        drugName: dataLayerEventObj.drugName,
        seoName: dataLayerEventObj.seoName,
        NDC: dataLayerEventObj.ndc,
        drugBrand: dataLayerEventObj?.drugType
          ? dataLayerEventObj?.drugType
          : dataLayerEventObj.isGeneric
          ? 'Generic'
          : 'Brand',
        drugForm: dataLayerEventObj.form,
        drugDosage: dataLayerEventObj.dosage,
        drugQuantity: dataLayerEventObj.quantity
      });
      props.setSavedDrugs(deleteDrugDrugsResponse);
    }
    setDeleteDrugModal(false);
  };

  const handleEditSuccess = async (quantity, isCustomQuantity, quantityObj) => {
    _.triggerGTMVirtualPageViewEvent({
      event: 'editDrugSubmit',
      drugName: dataLayerEventObj.drugName,
      seoName: dataLayerEventObj.seoName,
      NDC: quantityObj.ndc,
      drugBrand: quantityObj?.drugType
        ? quantityObj?.drugType
        : quantityObj.isGeneric
        ? 'Generic'
        : 'Brand',
      drugForm: quantityObj.form,
      drugDosage: quantityObj.dosage,
      drugQuantity: quantity
    });
    setIsEditDrug(false);
    const editDrugResponse = await editSavedDrug(
      editDrugData.id,
      quantityObj.ndc,
      quantity,
      props.savedDrugsData.saveDrugId,
      isCustomQuantity
    );
    if (editDrugResponse && editDrugResponse.saveDrugId) {
      props.setSavedDrugs(editDrugResponse);
      setDrugItems(
        editDrugResponse.drugItems.map(drug => ({
          ...drug,
          isEditLoading: false
        }))
      );
    } else {
      // Set loading of each drug to false for API error
      setDrugItems(
        props.savedDrugsData &&
          props.savedDrugsData.drugItems &&
          props.savedDrugsData.drugItems.map(drug => ({
            ...drug,
            isEditLoading: false
          }))
      );
      const errorMessage =
        editDrugResponse.message.code === 6
          ? 'The drug is already saved.'
          : 'Something went wrong.';
      setNotificationError(errorMessage);
      setTimeout(() => {
        setNotificationError('');
      }, 3000);
    }
  };

  return (
    <div className="saveDrugList">
      {!_.isEmpty(notificationError) && (
        <div className="notification visible">
          {notificationError}
          <span
            className="close-button"
            onClick={() => setNotificationError('')}
          >
            ×
          </span>
        </div>
      )}
      {!_.isEmpty(props.savedDrugsData.drugItems) && (
        <div className="clearBtnDiv">
          <button
            className="clearBtn"
            onClick={() => setClearAllSavedDrugs(true)}
          >
            Clear all
          </button>
        </div>
      )}
      {isLoading ? (
        <div className="loaderDiv">
          <Loader />
        </div>
      ) : _.isEmpty(drugItems) ? (
        <NoDrugs />
      ) : (
        <ul className="savedDrugWrapper">
          {drugItems &&
            drugItems
              .filter(drug => drug.isSpecialtyDrug !== null)
              .map((drug, key) => {
                const {
                  id,
                  drugName,
                  imageUrl,
                  seoName,
                  form,
                  dosage,
                  ndc,
                  quantity,
                  isGeneric,
                  isCustomQuantity,
                  displayQuantity,
                  isEditLoading
                } = drug;
                return (
                  <div key={key}>
                    {isEditLoading ? (
                      <div className="loaderDiv">
                        <Loader />
                      </div>
                    ) : (
                      <li key={key} className="listsRow">
                        <div className="drugInfoContent">
                          <div className="drugInfoList">
                            <div className="pharmacyImgs desktop-only">
                              <LazyLoadImage
                                src={imageUrl}
                                width="72px"
                                height="54px"
                                alt=""
                              />
                            </div>
                            <h3>{drugName}</h3>
                            <span>
                              {dosage}, {displayQuantity} {form}
                            </span>
                            {/* TODO Add logic here to check unavailble drugs */}
                            {drug.isSpecialtyDrug && (
                              <div className="unavailableDrug">
                                This dosage is no longer available. See drug
                                pricing for more details.
                              </div>
                            )}
                          </div>
                          <div className="drugAction">
                            <div className="desktop-only">
                              <ul className="d-flex">
                                <li
                                  onClick={() => {
                                    setDataLayerEventObj({ ...drug });
                                    setDeleteDrugId(id);
                                    setDeleteDrugModal(true);
                                  }}
                                >
                                  <LazyLoadImage
                                    src="/content/images/icons/icon-delete.svg"
                                    className="themeFocus"
                                    tabIndex="0"
                                    width="20px"
                                    height="20px"
                                    alt=""
                                  />
                                </li>
                                <li
                                  onClick={() => {
                                    drug.isEditLoading = true;
                                    setDataLayerEventObj({ ...drug });
                                    setEditDrugData(drug);
                                    _.triggerGTMVirtualPageViewEvent({
                                      event: 'savedEditDrug',
                                      drugName,
                                      seoName,
                                      NDC: ndc,
                                      drugBrand: drug?.drugType
                                        ? drug?.drugType
                                        : isGeneric
                                        ? 'Generic'
                                        : 'Brand',
                                      drugForm: form,
                                      drugDosage: dosage,
                                      drugQuantity: quantity
                                    });
                                    setIsEditDrug(true);
                                  }}
                                  className={drug.isSpecialtyDrug && 'disabled'}
                                >
                                  <LazyLoadImage
                                    src="/content/images/icons/icon-edit.svg"
                                    className="themeFocus"
                                    tabIndex="0"
                                    width="20px"
                                    height="20px"
                                    alt=""
                                  />
                                </li>
                              </ul>
                            </div>
                            <div className="mobile-only">
                              <LazyLoadImage
                                src="/content/images/icons/icon-rounded-more.png"
                                onClick={() => {
                                  setDataLayerEventObj({ ...drug });
                                  setDeleteDrugId(id);
                                  setEditDrugData(drug);
                                  setIsOpened(true);
                                }}
                                width="24px"
                                height="24px"
                                className="themeFocus"
                                tabIndex="0"
                              />
                            </div>
                          </div>
                          {!drug.isSpecialtyDrug && (
                            <div className="seeAllPriceBtn">
                              <a
                                onClick={() => {
                                  localStorage.setItem(
                                    'saveDrugGTMData',
                                    JSON.stringify({
                                      drugName,
                                      seoName,
                                      NDC: ndc,
                                      drugBrand: drug?.drugType
                                        ? drug?.drugType
                                        : isGeneric
                                        ? 'Generic'
                                        : 'Brand',
                                      drugForm: form,
                                      drugDosage: dosage,
                                      drugQuantity: quantity,
                                      pageTitle: document.title,
                                      pagePath: document.URL
                                    })
                                  );
                                  _.setCookie(
                                    'drugData',
                                    JSON.stringify([
                                      {
                                        drugName,
                                        seoName,
                                        dosage,
                                        form,
                                        ndc,
                                        quantity,
                                        isGeneric,
                                        isCustomQuantity,
                                        displayQuantity
                                      }
                                    ]),
                                    COOKIE_EXPIRY_2MIN
                                  );
                                }}
                                href={`/prescription/${drug.seoName}`}
                                className="pink themeFocus gradientPink"
                                role="link"
                              >
                                See all prices
                              </a>
                            </div>
                          )}
                        </div>
                      </li>
                    )}
                  </div>
                );
              })}
        </ul>
      )}
      {!_.isEmpty(drugItems) && (
        <p className="priceBanner textCenter">Prices are subject to change.</p>
      )}
      {deleteDrugModal && (
        <DialogModel
          setModal={setDeleteDrugModal}
          isModelOpen={deleteDrugModal}
          title="Delete drug?"
          description={
            <Fragment>
              Deleting this drug will remove it <br /> from your Saved Drugs.
            </Fragment>
          }
          handleDeleteSuccess={handleDeleteSavedDrug}
        />
      )}

      {isEditDrug && (
        <DrugDropdownModal
          editDrugData={editDrugData}
          setIsEditCouponDrug={setIsEditDrug}
          handleEditSuccess={handleEditSuccess}
          drugData={drugItems.map(drug => ({
            ...drug,
            isEditLoading: false
          }))}
          setDrugItems={setDrugItems}
        />
      )}

      {isClearAllSavedDrugs && (
        <DialogModel
          setModal={setClearAllSavedDrugs}
          isModelOpen={isClearAllSavedDrugs}
          title="Clear All?"
          description={
            <Fragment>
              This will delete all your <br /> Saved Drugs
            </Fragment>
          }
          handleDeleteSuccess={handleDeleteAllDrugs}
        />
      )}

      {isOpened && (
        <EditViewModal
          isEditDisabled={editDrugData.isSpecialtyDrug}
          setEditViewModal={setIsOpened}
          setDeleteDrugModal={setDeleteDrugModal}
          setIsEditDrug={setIsEditDrug}
          dataLayerEventObj={dataLayerEventObj}
          setDrugItems={setDrugItems}
          drugItems={drugItems}
        />
      )}
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    fetchSavedDrugs: () => dispatch(fetchSavedDrugs()),
    setSavedDrugs: data => dispatch(setSavedDrugs(data))
  };
};

function mapStateToProps(state) {
  return {
    savedDrugsData: state.userDrugs.savedDrugs
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SavedDrugsList);
